import { Container, Grid } from "@mui/material";
import { useEffect, useReducer } from "react";
import LoadingComponent from "src/components/application/LoadingComponent";
import ReKycApplicationForm from "src/components/application/ReKycApplicationForm";
import RekycThankYouPage from "src/components/application/ReKycThankYouPage";
import CustomizedSteppers from "src/components/application/Stepper";
import Layout from "src/components/core/Layout";
import OnfidoForm from "src/components/settings/onfido/OnfidoVerification";
import { setReKycApplicationStep } from "src/store/features/onboarding.slice";
import { useUserSlice } from "src/store/features/user.slice";
import { useAppDispatch } from "src/store/store";

export default function ReKycApplication() {
  const {
    reKycDetails: { reKyc, onfidoCheck, formSubmitted },
  } = useUserSlice();

  const isLoading = reKyc === false;

  useEffect(() => {
    if (onfidoCheck) {
      dispatch(setReKycApplicationStep("aboutYou"));
    }
  }, [onfidoCheck]);

  const [useDefaultTheme, toggle] = useReducer((theme: any) => !theme, true);

  const dispatch = useAppDispatch();

  return (
    <Layout toggleTheme={toggle} useDefaultTheme={useDefaultTheme}>
      {isLoading ? (
        <LoadingComponent message={"Getting things ready for you..."} />
      ) : (
        <Container sx={{ paddingLeft: "0px" }}>
          <Grid container item sx={{ marginBottom: { xs: "26px", sm: "26px", md: "0px" } }}>
            <CustomizedSteppers />
          </Grid>
          {onfidoCheck && <ReKycApplicationForm />}
          {!onfidoCheck && <OnfidoForm reason="Re KYC" />}
          {onfidoCheck && formSubmitted && <RekycThankYouPage />}
        </Container>
      )}
    </Layout>
  );
}
